export default __webpack_public_path__ + "static/media/remove_mobile.58218348.svg";